'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/apps/RentalCarApp/views/RentalCarUseType/RentalCarUseType.js';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sureComponents = require('sure-components');

var _PlanDisclaimer = require('shared/lib/components/PlanDisclaimer');

var _PlanDisclaimer2 = _interopRequireDefault(_PlanDisclaimer);

var _utils = require('shared/lib/utils');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isBoolean = require('lodash/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _analytics = require('shared/lib/analytics');

var analytics = _interopRequireWildcard(_analytics);

require('./RentalCarUseType.css');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  disclaimer: _propTypes2.default.string,
  isForPersonalUse: _propTypes2.default.bool,
  updateIsForPersonalUse: _propTypes2.default.func,
  plan: _propTypes2.default.object,
  navTo: _propTypes2.default.func,
  showGlobalModal: _propTypes2.default.func
};
var defaultProps = {
  disclaimer: null,
  isForPersonalUse: null,
  plan: {}
};

var RentalCarUseType = function (_Component) {
  _inherits(RentalCarUseType, _Component);

  function RentalCarUseType() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, RentalCarUseType);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RentalCarUseType.__proto__ || Object.getPrototypeOf(RentalCarUseType)).call.apply(_ref, [this].concat(args))), _this), _this.handleNext = function (e) {
      if (e) {
        e.preventDefault();
      }

      analytics.track('Rental Car - Next Button Clicked');

      if (_this.props.isForPersonalUse) {
        _this.props.navTo((0, _utils.resolveUrlPath)('driver'));
      } else {
        analytics.track('Rental Car - Ineligible for Business Use', {
          noninteraction: 1
        });

        _this.props.showGlobalModal({
          id: 'info',
          title: 'Ineligible for coverage',
          body: _react2.default.createElement('p', {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 45
            },
            __self: _this2
          }, 'At this time, rental car insurance is not available for business use. Sorry for the inconvenience.')
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RentalCarUseType, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      analytics.page('Rental Car - Use Type');
    }
  }, {
    key: 'handleUpdate',
    value: function handleUpdate(value) {
      this.props.updateIsForPersonalUse(value);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: 'RentalCarUseType',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60
        },
        __self: this
      }, _react2.default.createElement('div', {
        className: 'Container Container--small',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61
        },
        __self: this
      }, _react2.default.createElement('h1', {
        className: 'RentalCarUseType-title',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        },
        __self: this
      }, 'Is this car for personal or business use?'), _react2.default.createElement('form', {
        className: 'RentalCarUseType-form',
        autoComplete: 'off',
        onSubmit: this.handleNext,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        },
        __self: this
      }, _react2.default.createElement(_sureComponents.RadioButton, {
        name: 'is_for_personal_use',
        value: 'true',
        title: 'Personal',
        checked: this.props.isForPersonalUse === true,
        onChange: this.handleUpdate.bind(this, true),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        },
        __self: this
      }), _react2.default.createElement(_sureComponents.RadioButton, {
        name: 'is_for_personal_use',
        value: 'false',
        title: 'Business',
        checked: this.props.isForPersonalUse === false,
        onChange: this.handleUpdate.bind(this, false),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77
        },
        __self: this
      }), _react2.default.createElement('input', {
        type: 'submit',
        style: {
          display: 'none'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84
        },
        __self: this
      })), _react2.default.createElement(_sureComponents.PagerButtons, {
        isNextDisabled: !(0, _isBoolean2.default)(this.props.isForPersonalUse),
        onNext: this.handleNext,
        onBack: this.props.goBack,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86
        },
        __self: this
      }), _react2.default.createElement(_PlanDisclaimer2.default, {
        text: this.props.disclaimer,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 91
        },
        __self: this
      })));
    }
  }]);

  return RentalCarUseType;
}(_react.Component);

RentalCarUseType.propTypes = propTypes;
RentalCarUseType.defaultProps = defaultProps;
exports.default = RentalCarUseType;